module.exports = __webpack_public_path__ + "img/loader.303cb6d2.gif";